module.exports = __webpack_public_path__ + "images/emoji/mag.5ea37497f79113b63aae.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mag.png
// module id = LrSv
// module chunks = 14